
import { UserType } from '@/types/user';
import { Skeleton } from "@/components/ui/skeleton";

interface UserTypeDisplayProps {
  userType: string | null;
  isLoading?: boolean;
}

export function UserTypeDisplay({ userType, isLoading = false }: UserTypeDisplayProps) {
  // Return null to hide the component entirely for all users
  return null;
}
